import axios from "axios";
import { BASE_URL } from "../common/baseUrl";

export const paymentSaveAPi = (
    username:string,
    orderid:string,
    paymentCode:string,
    transactionInfo:{
    tranId:string|null,
    token:string|null, // this might be null for esewa
    amount:string
    })=>{

    return axios.put(`${BASE_URL}/order-queue/payment/success`,{
        username,
        orderid,
        paymentCode,
        transactionInfo
   
    });
}
//secured/order-queue/payment/failed
export const paymentFailed = (username:string,orderid:string,paymentCode:string,
  reason:string)=>{

    return axios.put(`${BASE_URL}/order-queue/payment/failed`,{
        username,
        orderid,
        paymentCode,
        reason
   
    });
}

